export default {
  menu: 'Purchases',
  title: 'Purchases',

  general: {
    status: {
      all: 'All',
      preInvoice: 'Draft',
      invoice: 'Invoice',
      receipt: 'Pull in',
      incomplete: 'Incomplete',
      deleted: 'Deleted',
      voided: 'Voided'
    },

    categoryTypes: {
      domestic: 'Domestic',
      import: 'Import',
      gift: 'Gift'
    },

    prompts: {
      confirm: {
        title: 'Insert purchase invoice confirmation',

        actions: {
          payment: 'Confirm',
          cancel: 'Cancel'
        }
      },
      activeInvoiceExist: {
        actions: {
          confirm: 'Invoice status changed, Save'
        }
      }
    },

    notifications: {
      quantity: 'There is not enough service!',
      dynamicQuantity: 'There is not enough service of {name}!',
      activeVariantsExists: 'There is not enough stock of {name}!',

      isExists: {
        message: 'Number of items added',
        dynamicMessage: 'There are {product} in the list'
      },
      increaseCount: {
        message: 'Number of items added',
        dynamicMessage: 'Number of {product} added'
      },
      cantUpdate: 'Invoice cant update because status is not draft or has vat',
      productNotFount: 'No product found with this barcode',
      activeRefundInvoiceExists: 'For this invoice, return invoice {invoices} are created. First, change the status of these invoices to drafts | For this invoice, return invoices {invoices} are created. First, change the status of these invoices to draft',
      activeInvoicesExists: 'For this invoice, sale invoice {invoices} are created. First, change the status of these invoices to drafts | For this invoice, return invoices {invoices} are created. First, change the status of these invoices to draft',

      insert: {
        success: 'Invoice registered successfully',
        error: 'Invoice registration was incorrect!'
      },

      edit: {
        success: 'Invoice successfully updated',
        error: 'Invoice update encountered error!'
      },

      delete: {
        success: 'The invoice was successfully deleted',
        error: 'Delete purchase invoice has error'
      },

      restore: {
        success: 'Invoice successfully restored',
        error: 'Restore purchase invoice was accompanied by an error'
      },

      refreshStatus: {
        success: 'Purchase invoice status returned successfully',
        error: 'Reverting invoice status returned failed'
      },

      parseError: {
        user: 'Supplier not selected!',
        lines: 'No items selected!',
        storeroom: 'Warehouse not selected!',
        unitPrice: 'The amount of the goods has not been entered!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'The number of selected products is not valid!',
        noProductEnter: 'No Product Selected!'
      }
    },

    confirmations: {
      editIncomplete: {
        title: 'Edit incomplete purchase invoice confirmation',
        body: 'If the purchase invoice is edited, all confirmed warehouse transfers related to the invoice will be deleted. are you sure?'
      },
      delete: {
        title: 'Delete purchase invoice confirmation',
        body: 'If the purchase invoice is deleted, all documents and warehouse transfers related to the invoice will be deleted. are you sure?'
      },
      deleteLine: {
        title: 'Delete purchase invoice line confirmation',
        body: 'Are you sure about delete "{name}" from purchase invoice?'
      },
      forceDelete: {
        title: 'Confirmation of deletion of purchase invoice',
        body: 'If the purchase invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      forceUpdate: {
        title: 'Purchase invoice edit confirmation',
        body: 'By edit purchase invoice, All documents related to this invoice change. Are you sure of confirming edit purchase invoice?'
      }
    }
  },

  list: {
    title: 'Purchases'
  },

  insert: {
    title: 'Add Purchase Invoice',
    dynamicTitle: 'Add {name} purchase invoice',

    table: {

      header: {
        row: 'Row',
        code: 'Code',
        product: 'Product',
        dynamic: 'Variable',
        number: 'Number',
        unitAmount: 'Unit amount',
        amount: 'Total amount',
        store: 'Store',
        action: '#'
      }
    }
  },

  invoice: {
    title: 'Purchase Invoice',
    dynamicTitle: 'Purchase Invoice No. {invoiceId}',
    dynamicTitleWithoutId: '{type} Purchase Invoice',

    general: {
      notifications: {
        insertReturnInvoiceError: 'Invoice in invoice purchase invoice not registered'
      },

      actions: {
        print: 'Print',
        back: 'Back'
      }
    },

    print: {
      preInvoice: 'Draft',
      invoice: 'Purchase invoice',

      labels: {
        date: 'Date',
        documentNumber: 'No',
        shipFrom: 'From',
        phone: 'Phone',
        address: 'Address',
        note: 'Note'
      }
    },

    logs: {
      title: 'Purchase Invoice Logs'
    }
  },

  edit: {
    title: 'Edit Purchase Invoice',
    dynamicTitle: 'Edit Purchase Invoice No. {invoiceId}',
    dynamicTitleWithoutId: 'Edit {type} Purchase Invoice'
  },

  trash: {
    title: 'Purchase invoice trash list'
  },

  refreshStatus: {
    title: 'Return Purchase Invoice Status',

    labels: {
      description: 'Note that if the invoice status is returned, all documents and delivery note related to each status will be deleted',
      accept: 'Confirm',
      cancel: 'Cancel'
    }
  },

  activeInvoiceExist: {
    title: 'In order to apply the changes, the status of the following invoices must first be changed to draft',

    table: {
      header: {
        id: 'Invoice number',
        type: 'Type',
        user: 'Customer',
        date: 'Date',
        status: 'Status'
      }
    },

    invoiceTypes: {
      1: 'Sale',
      2: 'Purchase',
      3: 'Sale Refund',
      4: 'Purchase Refund'
    },
    warehouseConversion: 'Conversion'
  }
}
